'use client';

import _defineProperty from "/codebuild/output/src3766/src/s3/01/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/codebuild/output/src3766/src/s3/01/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["filled", "children", "offset", "disabled", "marksOffset", "inverted", "containerProps"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { jsx, Fragment, jsxs } from 'react/jsx-runtime';
import 'react';
import '@mantine/hooks';
import 'clsx';
import '../../../core/MantineProvider/Mantine.context.mjs';
import '../../../core/MantineProvider/default-theme.mjs';
import '../../../core/MantineProvider/MantineProvider.mjs';
import '../../../core/MantineProvider/MantineThemeProvider/MantineThemeProvider.mjs';
import '../../../core/MantineProvider/MantineCssVariables/MantineCssVariables.mjs';
import { Box } from '../../../core/Box/Box.mjs';
import '../../../core/DirectionProvider/DirectionProvider.mjs';
import { Marks } from '../Marks/Marks.mjs';
import { useSliderContext } from '../Slider.context.mjs';
function Track(_ref) {
  var filled = _ref.filled,
    children = _ref.children,
    offset = _ref.offset,
    disabled = _ref.disabled,
    marksOffset = _ref.marksOffset,
    inverted = _ref.inverted,
    containerProps = _ref.containerProps,
    others = _objectWithoutProperties(_ref, _excluded);
  var _useSliderContext = useSliderContext(),
    getStyles = _useSliderContext.getStyles;
  return /* @__PURE__ */jsx(Fragment, {
    children: /* @__PURE__ */jsx(Box, _objectSpread(_objectSpread(_objectSpread({}, getStyles("trackContainer")), {}, {
      mod: {
        disabled: disabled
      }
    }, containerProps), {}, {
      children: /* @__PURE__ */jsxs(Box, _objectSpread(_objectSpread({}, getStyles("track")), {}, {
        mod: {
          inverted: inverted,
          disabled: disabled
        },
        children: [/* @__PURE__ */jsx(Box, _objectSpread({
          mod: {
            inverted: inverted,
            disabled: disabled
          },
          __vars: {
            "--slider-bar-width": "calc(".concat(filled, "% + var(--slider-size))"),
            "--slider-bar-offset": "calc(".concat(offset, "% - var(--slider-size))")
          }
        }, getStyles("bar"))), children, /* @__PURE__ */jsx(Marks, _objectSpread(_objectSpread({}, others), {}, {
          offset: marksOffset,
          disabled: disabled,
          inverted: inverted
        }))]
      }))
    }))
  });
}
Track.displayName = "@mantine/core/SliderTrack";
export { Track };